import { render, staticRenderFns } from "./CheapCarsForSale.vue?vue&type=template&id=3c97c2e0&scoped=true"
import script from "./CheapCarsForSale.vue?vue&type=script&lang=js"
export * from "./CheapCarsForSale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c97c2e0",
  null
  
)

export default component.exports